/* eslint-disable react/jsx-props-no-spreading */
import {
    useCallback,
} from 'react'
import noop from 'lodash/noop'

import {
    Moment,
} from 'moment'
import {
    dateToStr,
    dateTimeMask,
} from 'app/utils/date'

import DateTimeSelect, {
    DateTimeSelectProps,
} from './DateTimeSelect'

type Props = DateTimeSelectProps & {
    onChange?: (value: string, event: {
        name: string,
        value: string,
    }) => void,
}

const EMPTY_STRING = ''

const DateTimeSelectContainer = ({
    name = EMPTY_STRING,
    onChange = noop,
    ...rest
}: Readonly<Props>) => {
    const handleOnChange = useCallback((datetime: Moment) => {
        const newDate = dateToStr(datetime, dateTimeMask)

        onChange(newDate, {
            name,
            value: newDate,
        })
    }, [
        name,
        onChange,
    ])

    return (
        <DateTimeSelect
            {...rest}
            name={name}
            onChange={handleOnChange}
        />
    )
}

export default DateTimeSelectContainer
